var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7678 17.6088C22.0249 17.892 22.2287 18.2282 22.3677 18.5982C22.5066 18.9682 22.578 19.3647 22.5776 19.765V19.765C22.5776 20.5732 22.2859 21.3484 21.7666 21.9199C21.2473 22.4914 20.543 22.8125 19.8087 22.8125H4.44867C3.71429 22.8125 3.00999 22.4914 2.4907 21.9199C1.97142 21.3484 1.67969 20.5732 1.67969 19.765V19.765C1.67937 19.3647 1.75072 18.9682 1.88967 18.5982C2.02862 18.2282 2.23244 17.892 2.48948 17.6088L4.29193 15.625V9.875C4.29193 7.58751 5.11759 5.39371 6.58726 3.7762C8.05693 2.1587 10.0502 1.25 12.1287 1.25V1.25C14.2071 1.25 16.2004 2.1587 17.6701 3.7762C19.1397 5.39371 19.9654 7.58751 19.9654 9.875V15.625L21.7678 17.6088ZM16.047 22.8125H8.2103C8.2103 23.9562 8.62312 25.0531 9.35796 25.8619C10.0928 26.6706 11.0894 27.125 12.1287 27.125C13.1679 27.125 14.1645 26.6706 14.8994 25.8619C15.6342 25.0531 16.047 23.9562 16.047 22.8125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.18eb21425365c6eb4fd6325da282d955.svg";
export { ForwardRef as ReactComponent };